// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"500":"76ee2226","876":"76ee2226"}[chunkId] + ".chunk.css";
};